import { DEFAULT_FILTER_VALUE } from '../../constants/PremiumConstants';
import { ACTION } from './interfaces';

import type { FreemiumAction, IFreemiumState } from './interfaces';

const INIT_FREEMIUM_STATE: IFreemiumState = {
  featuresOfPremiumRef: null,
  isListingActive: false,
  filters: {
    filterType: 'cityState',
    beds: DEFAULT_FILTER_VALUE,
    propertyType: DEFAULT_FILTER_VALUE,
  },
  canAccessTopOfFunnelPremium: false,
};

const reducer = (state: IFreemiumState, action: FreemiumAction): IFreemiumState => {
  switch (action.type) {
    case ACTION.UPDATE_FILTERS: {
      const { filters } = (action as Extract<FreemiumAction, { type: ACTION.UPDATE_FILTERS }>).payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          ...filters,
        },
      };
    }
    case ACTION.UPDATE_DATA: {
      const { data } = (action as Extract<FreemiumAction, { type: ACTION.UPDATE_DATA }>).payload;
      return {
        ...state,
        ...data,
      };
    }
    case ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM: {
      const { canAccessTopOfFunnelPremium } = (
        action as Extract<FreemiumAction, { type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM }>
      ).payload;
      return {
        ...state,
        canAccessTopOfFunnelPremium,
      };
    }

    default: {
      return state;
    }
  }
};

export { INIT_FREEMIUM_STATE };

export default reducer;
